import instance from 'utils/apiCalls';
import { SmtpConfigI } from '../../../types/interface';
import { SMTP_COMFIG_URLS } from './smtpConfigUrls';

export const submitSmtpConfig = (data: SmtpConfigI) => () => {
  const response = instance.post(SMTP_COMFIG_URLS.SUBMIT_SMTP, data);
  return response;
};

export const getSmtpConfig = () => () => {
  const response = instance.get(SMTP_COMFIG_URLS.GET_SMTP);
  return response;
};
